//Generator Url: http://localhost:8033/api/UserWeChatLogin/getApi
import request from '~/utils/request';
//import './UserWeChatLoginApi.d';
export namespace UserWeChatLoginApi {
    export const add = (param: IUserWeChatLoginCreateParam, loadingOptions?: IRequestLoadingOption) => request<IUserWeChatLoginResult>({
        method: 'post',
        url: 'UserWeChatLogin/Add',
        data: param,
        loadingOptions
    })

    export const get = (param: Partial<IUserWeChatLoginGetParam>, loadingOptions?: IRequestLoadingOption) => request<IUserWeChatLoginResult>({
        method: 'post',
        url: 'UserWeChatLogin/Get',
        data: param,
        loadingOptions
    })

    export const confirm = (param: IUserWeChatLoginConfirmParam, loadingOptions?: IRequestLoadingOption) => request<void>({
        method: 'post',
        url: 'UserWeChatLogin/Confirm',
        data: param,
        loadingOptions
    })

    /**用户使用微信扫码登录*/
    export const signIn = (param: IUserWeChatLoginSignInParam, loadingOptions?: IRequestLoadingOption) => request<void>({
        method: 'post',
        url: 'UserWeChatLogin/SignIn',
        data: param,
        loadingOptions
    })

    // ------------ model define ------------- //


    export interface IUserWeChatLoginResult {

        Id: string

        OpenId?: NString

        Mobile?: NString
        /**创建时间
        *System.DateTime*/
        Created?: NString
        /**过期时间
        *System.DateTime*/
        Expires?: NString
        /**完成时间
        *System.Nullable`1[System.DateTime]*/
        Completed?: NString
        /**标识会话已过期
        *System.Boolean*/
        IsExpired: boolean
        /**微信确认链接
        *System.String*/
        ConfirmUrl?: NString

        UserName?: NString
    }


    export interface IUserWeChatLoginCreateParam {
    }


    export interface IUserWeChatLoginGetParam {

        Id: string

        Scan: boolean
    }


    export interface IUserWeChatLoginConfirmParam {

        Id: string
    }


    export interface IUserWeChatLoginSignInParam {

        Id: string
    }

}
export default UserWeChatLoginApi